export const ADMIN = 'ADMIN';
export const WAIVER = 'WAIVER';
export const STATIC = 'STATIC';
export const SUPER = 'SUPER';